import { defineStore } from "pinia";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { validateEmail } from "@bloglovin/vue-component-library";

export const useInviteUserStore = defineStore(
  "invite-user-store",
  {
    state: () => ({
      firstName: "",
      lastName: "",
      email: "",
      firstNameValidationError: "",
      lastNameValidationError: "",
      emailValidationError: "",
    }),

    getters: {
      isInviteUserLoading() {
        return useCreatorPublicationStore().loadingAddUser;
      },
      addUserErrorMessage() {
        return useCreatorPublicationStore().addUserError;
      },
    },

    actions: {
      resetForm() {
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.firstNameValidationError = "";
        this.lastNameValidationError = "";
        this.emailValidationError = "";
      },

      inviteUser(publicationId, onSuccess = () => {
      }) {
        this.firstNameValidationError = "";
        this.lastNameValidationError = "";
        this.emailValidationError = "";

        if (!this.firstName) {
          this.firstNameValidationError = "First name is required";
        }
        if (!this.lastName) {
          this.lastNameValidationError = "Last name is required";
        }
        if (!this.email) {
          this.emailValidationError = "Email is required";
        }
        if (!validateEmail(this.email)) {
          this.emailValidationError = "Please enter a valid email address";
        }

        if (this.firstNameValidationError || this.lastNameValidationError || this.emailValidationError) {
          return;
        }

        useCreatorPublicationStore().addPublicationUser({
          publicationId: publicationId,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          onSuccess: () => {
            this.resetForm();
            onSuccess();
          },
        });
      },
    },
  },
);
